import { render, staticRenderFns } from "./HtPage.vue?vue&type=template&id=36d18d99&scoped=true&"
import script from "./HtPage.vue?vue&type=script&lang=js&"
export * from "./HtPage.vue?vue&type=script&lang=js&"
import style0 from "./HtPage.vue?vue&type=style&index=0&id=36d18d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d18d99",
  null
  
)

export default component.exports